var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRunningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 50 50",
    height: "50px",
    id: "Layer_1",
    viewBox: "0 0 50 50",
    width: "50px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 50,
    width: 50
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "  M32,5.499C32,7.984,34.014,10,36.498,10C38.987,10,41,7.984,41,5.499C41,3.016,38.987,1,36.498,1C34.014,1,32,3.016,32,5.499z",
    fill: "none",
    stroke: "#5E81F4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "  M19.332,26.559l-4.076,5.895c0,0-6.795,0.473-9.226,0.615c-1.86,0.109-2.979,0.804-2.979,2.01s0.942,1.884,3.624,2.099  c2.261,0.181,9.988,0.652,9.988,0.652c0.009,0,0.018,0,0.024,0c0.903,0,1.849-0.479,2.47-1.396l3.978-5.681",
    fill: "none",
    stroke: "#5E81F4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "  M34.842,31.451l-6.904-4.731l7.025-11.253c0.402-0.6,0.682-2.203,0.083-2.607L31.1,10.211c-0.275-0.236-0.604-0.417-0.984-0.5  l-7.892-1.716c-0.609-0.126-1.24-0.007-1.754,0.339l-6.489,5.012c-1.066,0.923-2.088,2.077-1.385,3.115  c0.451,0.671,1.991,0.289,2.799-0.202l6.811-3.617l4.484,0.977l-6.047,8.986c-1.387,2.401-1.848,4.253,0.647,6.378l8.594,5.683  l-3.593,8.87c-1.355,3.251-1.112,4.918-0.184,5.311s2.293-0.059,4.222-3.596l5.463-10.44C36.328,33.609,35.928,32.197,34.842,31.451  z",
    fill: "none",
    stroke: "#5E81F4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "  M33.084,19.029l1.742,4.181c0.324,0.728,1.06,1.435,1.852,1.53c0,0,5.533-0.119,7.043-0.202c1.587-0.086,3.365-0.384,3.404-1.471  c0.058-1.558-1.413-1.673-2.842-1.776l-5.581-0.474l-3.308-7.497",
    fill: "none",
    stroke: "#5E81F4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunningIcon);
export default __webpack_public_path__ + "static/media/running_icon.9981cc156ee956dbff3e09dcf6d47fdb.svg";
export { ForwardRef as ReactComponent };